module.exports = __webpack_public_path__ + "static/media/apiRestful.c6b9351a.png";